var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-page"},[_c('div',{staticClass:"chat-con"},[_c('iframe',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":_vm.chatUrl,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }